import { FC } from 'react';

import { IconFormer } from '@shared/components/IconsFormer';
import { Icon } from '@shared/components/icons';

export const GiftCallHelperBox: FC = function GiftCallHelperBox() {
  const { CustomerCenter } = Icon();

  const promotionText = () => {
    const now = new Date();
    if (now.getHours() <= 20) {
      return (
        <p className="whitespace-pre">
          결제가 어려우신가요?{' '}
          <span className="theme-text-main">친절하게 도와드립니다</span>
        </p>
      );
    } else {
      return (
        <p>
          답례품 주문 관련
          <span className="theme-text-main">&nbsp;문의안내</span>
        </p>
      );
    }
  };

  return (
    <div className="p-4 py-4 theme-bg-1">
      <div className="center-box text-base font-bold">{promotionText()}</div>
      <div className="center-box relative gap-4 font-bold">
        <div className="center-box flex-col items-center">
          <CustomerCenter />
          <p>전화주문 및 안내</p>
          <p className="break-keep theme-text-main">오전10시-오후6시</p>
        </div>
        <div className="space-y-2">
          <a href="tel:15331429">
            <div className="flex items-center gap-2 text-[21px]">
              <IconFormer.Phone className="wh-5 fill-gray-700" />
              <p>1533-1429</p>
            </div>
          </a>
          <p className="break-keep text-xs">클릭시 상담원에게 바로 연결됩니다</p>
        </div>
      </div>
    </div>
  );
};
